import {
    GET_WISHLIST_ITEM_BY_ID_SUCCESS,
    GET_WISHLIST_ITEMS_SUCCESS,
    GET_WISHLIST_UPDATES_COUNT_SUCCESS,
    MARK_WISHLIST_SEEN,
} from './wishlist.types';

const initialState = {
    /** `{ data, count }` — one page of this org's requests. Rows carry no attachment URLs. */
    wishlistItems: { data: [], count: 0 },
    /**
     * The request open in the details/edit modal, with signed attachment URLs.
     * The URLs expire, so this is a snapshot of one modal open.
     */
    wishlistItem: null,
    /** My requests TherapyLake updated since I last opened them — drives the sidebar red dot. */
    updatesCount: 0,
};

export const wishlistReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WISHLIST_ITEMS_SUCCESS:
            return {
                ...state,
                wishlistItems: action.payload,
            };

        case GET_WISHLIST_ITEM_BY_ID_SUCCESS:
            return {
                ...state,
                wishlistItem: action.payload,
            };

        case GET_WISHLIST_UPDATES_COUNT_SUCCESS:
            return {
                ...state,
                updatesCount: action.payload,
            };

        // Optimistic: the dot goes the moment the request is opened. The saga
        // re-reads the count afterwards, so a failed write corrects itself.
        case MARK_WISHLIST_SEEN: {
            const wasUnseen = state.wishlistItems.data.some((row) => row.id === action.payload?.id && row.hasUpdate);
            return {
                ...state,
                wishlistItems: {
                    ...state.wishlistItems,
                    data: state.wishlistItems.data.map((row) =>
                        row.id === action.payload?.id ? { ...row, hasUpdate: false } : row
                    ),
                },
                updatesCount: wasUnseen ? Math.max(0, state.updatesCount - 1) : state.updatesCount,
            };
        }

        default:
            return state;
    }
};
